import React from 'react'
import Link from 'gatsby-link'

import PageHeader from '../__components/PageHeader'
import PAGE_HEADER from '../img/pageheaders/services_juvederm.jpg'

import ShareButtons from '../__components/ShareButtons'

const pageMeta = {
  title: "Juvederm Fillers",
  desc: '"Juvederm facial fillers are hyaluronic acid injectable treatments that reduce lines and wrinkles and provide lift by restoring volume."'
};
const AboutPage = ({ transition }) => (
  <div style={transition && transition.style} className="page">
    <PageHeader bgPhoto={PAGE_HEADER} contain={true} styles={{ backgroundColor: "#e9e9e9" }} />

    {typeof window !== 'undefined' &&
      <ShareButtons location={location.href} desc={pageMeta.desc} />
    }

    <div className="container">
      <div className="title-bar">
        <h1>{pageMeta.title}</h1>
        <p>{pageMeta.desc}</p>
      </div>

      <p>The effects can last up to 24 months.  They are optimally used in combination with Botox treatments.</p>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/services-juvederm-fillers.js